import { Http } from "../Http";
import { AxiosPromise } from "axios";
import { getUserAccessToken } from "../selectors/Accounts";

export default class SettingService {
	public static settingGetList() {
		return Http.axios()
			.get("/api/Messages/get-message-board-list", {
				headers: { Authorization: getUserAccessToken() },
			})
			.catch((e: { response: any }) => {
				return e.response;
			}) as AxiosPromise<any>;
	}

	public static settingStatusUpdate(input: any) {
		return Http.axios()
			.post("/api/Messages/updatehotlinefeature", input, {
				headers: { Authorization: getUserAccessToken() },
			})
			.then((res: any) => {
				return res;
			})
			.catch((e: any) => {
				return e.response;
			}) as AxiosPromise<any>;;
	}

	public static settingContentUpdate(input: any) {
		return Http.axios()
			.put("/api/Messages/update-message-board-byid", input, {
				headers: { Authorization: getUserAccessToken() },
			})
			.then((res: any) => {
				return res;
			})
			.catch((e: any) => {
				return e.response;
			}) as AxiosPromise<any>;;
	}

	public static getSettingContent(input: any) {
		return Http.axios()
			.get("/api/Messages/get-messageboard-byid/" + input, {
				headers: { Authorization: getUserAccessToken() },
			})
			.then((res: any) => {
				return res;
			})
			.catch((e: any) => {
				return e.response;
			}) as AxiosPromise<any>;;
	}

	public static getDashboardList() {
		return Http.axios()
			.get("/api/Messages/get-dashboard-list", {
				headers: { Authorization: getUserAccessToken() },
			})
			.then((res: any) => {
				return res;
			})
			.catch((e: any) => {
				return e.response;
			}) as AxiosPromise<any>;;
	}
}
